module.exports = __webpack_public_path__ + "static/media/user-delete.25e6022f.svg";